import $ from 'jquery';
import Cookies from 'js-cookie';
import ScrollMagic from 'scrollmagic';
import { initComparisons, imgComparisonSlides } from './img-compare.js';
import './form.js';
import './app.js';

window.jQuery = window.$ = $;
var controller = new ScrollMagic.Controller();
let screenshotReady, imgslider, formThanks;




const get_URL_params = (sParam) => {
  //console.log('sParam',sParam)
  let sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName;

  for (let i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
}


const screenshot_functions = () => {



  screenshotReady = get_URL_params('screenshot');
  imgslider = get_URL_params('imgslide');
  formThanks = get_URL_params('thanks');

  if (screenshotReady) {
    console.log('mobile_screen_mod ----');
    $('html, body').animate({ scrollTop: 0 }, 1000);
    $('body').css('overflow', 'initial').addClass('screenshot');
  }

  if (imgslider) {
    console.log('img slider - set height to 810px - mobile to 715')
    let thisTop = 270;
    if ($(window).width() < 768) {
      thisTop = 300;
    }
    window.scrollTo({ top: thisTop });
    $('body').css('overflow', 'initial').addClass('imgslide');
  }

  if (formThanks) {
    console.log('thanks');
    $('body').addClass('thanks');
  }

}
function isElementInViewport(element) {

  var elementTop = $(element).offset().top;
  var elementBottom = elementTop + $(element).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
}
const gtm_events = () => {
  let isi_visible = false;
  let init_scroll = false;

  $(window).scroll(function () {

    // log gtm event on scroll
    if (!init_scroll) {
      window.dataLayer.push({ 'event': 'custom_scroll_JS_start' });
      init_scroll = true;
    }

    // add gtm class to isi when visible
    if (isElementInViewport('#isi') && !isi_visible) {
      //$('#isi').addClass('gtm-scrolled-to-top-of-isi');
      //console.log('isi visible')
      window.dataLayer.push({ 'event': 'gtm_scrolled_to_top_of_isi' });
      isi_visible = true;
    }
  })
}

const getSavingsCard = () => {

  let xmlResponse,
    DocumentNumber,
    GroupNumber,
    RegistrationID,
    BinNumber,
    RxPCN;
  if ($('#get-savings-card').length) {
    const checkAllcheck = () => {
      let thisStatus = true;
      $('#savings-card-popup input').each(function () {
        if ($(this).is(':checked') == false) {
          thisStatus = false;
          return;
        }
      })
      return thisStatus;
    }


    $('#get-savings-card').click(function (e) {
      //console.log('get savings')
      //e.preventDefault();
      $('#popup-container').addClass('active savings-card-popup');
      $('#savings-card-popup').show();
      $('#section-getcard').show();
      $('#section-checkdownload').hide();
      $('#section-getcard input').prop('checked', false);
      $('#loading-card').hide()
      $('#download-card').show();

    })
    $('#savings-card-popup input').change(function () {
      if (checkAllcheck()) {
        $('#download-card, #loading-card').removeClass('showerror');
      } else {
        $('#download-card #loading-card').addClass('showerror');
      }
    })

    $('#download-card').click(function () {

      $(`#savings-card-popup, .input-wrap`).removeClass('error');
      $(`#savings-card-popup  p.error`).hide();

      let isReadySubmit = true;
      $('#savings-card-popup input').each(function () {
        if ($(this).is(':checked') == false) {
          let thisErrorId = $(this).attr('id');
          $(`#savings-card-popup, .input-wrap.${thisErrorId}`).addClass('error');
          $(`#savings-card-popup > #section-getcard >.error.${thisErrorId}`).show();
          isReadySubmit = false;
        }
      })
      if (isReadySubmit) {
        $('#download-card').hide();
        $('#loading-card').css('display', 'flex');
        $('#popup-container > .popup-box').addClass('loading-card-box');

        const lambdaURL_TEST = "https://npyenzvqryejhwlyjv4lfekkw40xgcsb.lambda-url.us-east-1.on.aws/";

        const lamdaURL_PROD = "https://clydu3ph3zkghiwq32gsfp3ema0xoquc.lambda-url.us-east-1.on.aws/";


        $.ajax({
          url: lamdaURL_PROD,
          type: "GET", // or "POST" if your Lambda expects a body
          dataType: "json",
          success: function (data) {

            let jsonString = JSON.stringify(data);
            let encodedStringBtoA = btoa(jsonString);
            window.location.href = `/savings-card.html?c=${encodedStringBtoA}`;

            $('#download-card').show();
            $('#loading-card').hide();


            $('#savings-card-popup input').prop('checked', false);
            $('#popup-container').removeClass('active wide');
            $('.popup-content').hide();
            $('#section-getcard').hide();
            $('#popup-container .popup-box').removeClass('loading-card-box');
            $('#section-checkdownload').show().find('h3').text('Please check your download folder for your Patient Savings Card');

          },
          error: function (xhr) {

            $('#popup-container .popup-box').removeClass('loading-card-box');
            $('#section-checkdownload').show().find('h3').text('Error: Please refresh your browser and try again');
            $('#section-getcard').hide();

            console.log('error', xhr.status, xhr.responseText);
          }
        });
      }
    })

  }
}
const printSavingsCard = () => {

  let RxBIN, RxPCN, RxGRP, RxID, base64string;
  const mobilePrint = () => {
    if ($(window).width() < 767) {
      $('.card-overlay').addClass('isMobile');
    } else {
      $('.card-overlay').removeClass('isMobile');
    }
  }
  // RxBIN = get_URL_params('bin');
  // RxPCN = get_URL_params('pcn');
  // RxGRP = get_URL_params('grp');
  // RxID = get_URL_params('id');


  base64string = get_URL_params('c');
  if (base64string) {
    let encodedStringAtoB = atob(base64string);
    let cardData = JSON.parse(encodedStringAtoB);

    RxBIN = cardData.BinNumber;
    RxPCN = cardData.RxPCN;
    RxGRP = cardData.GroupNumber;
    RxID = cardData.DocumentNumber;

    console.log(cardData.lambdaVersion)
  }



  mobilePrint();
  if ($('#savingscard').length) {
    $('.rxbin').text(RxBIN);
    $('.rxpcn').text(RxPCN);
    $('.rxgrp').text(RxGRP);
    $('.rxid').text(RxID);
  }

  $(window).resize(function () {
    mobilePrint();
  })
}

function openPopUp (){
  $('.open-pop-up').click(function(e){
    e.preventDefault();
    let thisPopupID = $(this).data('popupid');
    $(`#popup-container`).addClass('active');
    $(`#popup-container, #${thisPopupID}`).show();
    //$(this).attr('popup-name').show();
  })
}

function closePopUp() {
  $('#closePopUp, .popup-outside').click(function () {
    $('#popup-container').removeClass('active wide');
    $('.popup-content').hide();
  })
}


$(document).ready(function () {
  $.fn.extend({
    toggleText: function (a, b) {
      return this.text(this.text() == b ? a : b);
    }
  });

  // Set cookies

  // if (Cookies.get('privacy-policy')) {
  //   $("#cookies-modal").hide();
  //   $("#overlay").hide();
  // } else {
  //   $("#cookies-modal").show();
  //   $("#overlay").show();
  // }

  $("#cookies-button, #close").on("click", function () {
    Cookies.set('privacy-policy', true);
    $("#cookies-modal").hide();
    $("#overlay").hide();
  });

  // Hide cookie notice close (Temp)
  $("#close").on("click", function () {
    $("#cookies-modal").hide();
    $("#overlay").hide();
  });




  // Generate overlay isi
  var isiSection = $("#isi").html();
  $(".overlay-isi").append(isiSection);

  // Hide overlay ISI when the full ISI comes into view
  new ScrollMagic.Scene({ triggerElement: "#isi", offset: -180 })
    .on('enter', () => {
      $(".overlay-isi").hide();
    })
    .on('leave', () => {
      $(".overlay-isi").show();
    })
    .addTo(controller);

  $('.overlay-isi .btn').click(function () {
    $("body").toggleClass('isi-opened');
    //$('body').hasClass('menu-opened') ? $('body').removeClass('menu-opened') : null;
    $('body').removeClass('menu-opened');
    $('header .button').text('Menu');
    if ($('body').hasClass('isi-opened')) {
      $(this).text('Close');
    } else {
      $(this).text('Expand');
    }

  });

  $('header .button').click(function () {
    $("body").toggleClass('menu-opened');
    //$('body').hasClass('isi-opened') ? $('body').removeClass('isi-opened') : null;
    $('body').removeClass('isi-opened');
    $('.overlay-isi .btn').text('Expand');
    if ($('body').hasClass('menu-opened')) {
      $(this).text('Close');
    } else {
      $(this).text('Menu');
    }

  });

  $('header li.isi-link').click(function (e) {
    e.preventDefault();
    $('body').removeClass('menu-opened, isi-opened');
    $('header .button').text('Menu');
    $('.overlay-isi .btn').text('Expand');
    $([document.documentElement, document.body]).animate({
      scrollTop: $("#isi").offset().top
    }, 500);
  })



  if ($('#slider-wrapper').length) {
    initComparisons();
    imgComparisonSlides();
  }

  $('.isi-link').click(function () {
    $('body').removeClass('menu-opened')
  })

  // window resize
  $(window).resize(function () {
    let windowW = $(this).width();
    if (windowW > 950) {
      $('body').removeClass('menu-opened');
      $('header .button').text('Menu');
    }
  })


  screenshot_functions();
  gtm_events();
  getSavingsCard();
  openPopUp();
  closePopUp();
  printSavingsCard();

  	$("#myForm").submit(function (event) {
		event.preventDefault(); // Prevent the default form submission

		$.post({
			url: $(this).attr("action"), // Get the form's action URL
			data: $(this).serialize(), // Serialize form data
			success: function (response) {
				// Handle success (e.g., display a message)
				alert("Form submitted successfully!");
			},
			error: function (error) {
				// Handle error (e.g., display an error message)
				alert("Error submitting form.");
			}
		});
	});
});

